<template>
  <div
    :aria-pressed="selected"
    class="button-calendar-quick-select"
    :class="{
      'button-calendar-quick-select__selected': selected
    }"
    role="button"
    tabindex="0"
    @click="onClicked"
    @keydown.enter="onClicked"
    @keydown.space="(event: Event) => onClicked(event, true)"
  >
    <slot></slot>
    <SvgDisplay v-if="src" :src="src" :style="{ color: '#767676' }" />
    <div class="button-calendar-quick-select__textbox">
      <span class="button-calendar-quick-select__textbox__title"> {{ title }}</span>
      <span class="button-calendar-quick-select__textbox__subtitle"> {{ subtitle }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import SvgDisplay from '../SvgDisplay.vue'
import { Ref } from 'vue'

type Props = {
  title: string
  subtitle?: string | Ref<string>
  selected: boolean
  src?: string
}

defineProps<Props>()

const emit = defineEmits(['onClicked'])

function onClicked(event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  emit('onClicked')
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins.scss';
@use '@/design-system/design-tokens/variables.scss';
.button-calendar-quick-select {
  align-items: center;
  background: variables.$color-pure-white;
  border-radius: variables.$border-radius-small;
  border: variables.$button-text-icon-border;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: variables.$gap-xlarge;
  padding: variables.$padding-large variables.$padding-xlarge;
  box-sizing: initial;
  svg {
    stroke: aqua;
  }
  &:hover {
    border: variables.$button-outline-border;
    margin: -1px;
  }
  &__selected {
    border: variables.$button-outline-border;
    outline: variables.$button-text-icon-outline;
    margin: -1px;
  }
  &__textbox {
    display: flex;
    flex-direction: column;
    &__title {
      @include font-mixins.desktop-bold-label;
      color: variables.$color-greyscale-content;
    }
    &__subtitle {
      @include font-mixins.desktop-regular-label;
      color: variables.$color-greyscale-secondary;
    }
  }
}
</style>
